export default "__VITE_ASSET__BE5mJ47L__"